import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import styled from 'styled-components';
import { useModal, useCookiePreferences, CookiePreferences, BxpButton, getAppearance, getProminence, getSpacing, X } from '../../components';
import { colorCSS } from '../../styles';
export default function UiCookieBanner({ model }) {
    const { isGdprUser, hasGdprConsented, hasOptedOut, setGdprConsent } = useCookiePreferences();
    const [showBanner, setShowBanner] = useState(isGdprUser && !hasGdprConsented && !hasOptedOut);
    const banner = useModal(model.id, showBanner);
    const acceptCookies = () => {
        setGdprConsent(true);
        setShowBanner(false);
    };
    const { acceptCookieText, bannerText, cookiePreferences } = model.content;
    if (!banner) {
        return null;
    }
    return createPortal(React.createElement(BannerContainer, null,
        React.createElement("p", null, bannerText),
        React.createElement("div", null,
            React.createElement(CookiePreferences, Object.assign({ id: cookiePreferences.id, type: model.type }, cookiePreferences.content, { onClose: () => setShowBanner(false) })),
            React.createElement(BxpButton, { bxpAppearance: getAppearance('Creative'), bxpProminence: getProminence('Reduced'), bxpSpacing: getSpacing('Left') },
                React.createElement("button", { onClick: acceptCookies }, acceptCookieText))),
        React.createElement("div", null,
            React.createElement(CloseButton, { onClick: acceptCookies },
                React.createElement(X, { color: "N500" })))), banner);
}
const BannerContainer = styled.div `
  background-color: ${colorCSS('N0')};
  border-top: 1px solid ${colorCSS('N40')};
  box-shadow: rgba(0, 0, 0, 0.3) 0px 0px 10px 0px;
  font-size: 1rem;
  padding: 1rem 2.5rem;
  position: fixed;
  bottom: 0;
  width: 100%;
  text-align: center;
  z-index: 1;
  p {
    margin: 0 auto;
    margin-bottom: 1rem;
    max-width: 1140px;
  }
  button {
    color: ${colorCSS('B400')};
    font-size: 1rem;
  }
`;
const CloseButton = styled.button `
  appearance: none;
  background: transparent;
  border: none;
  position: absolute;
  top: 0;
  right: 0;
`;
//# sourceMappingURL=UiCookieBanner.js.map